module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--35.bce998eb.png";